// Single source of truth for the blog's name. public/index.html and public/manifest.json are static; keep them in sync by hand.
export const SITE_NAME = "Books, Thoughts & Good Dogs";
export const TAGLINE = "nothing comes easy, but the dogs are good";
